import type { IconSvgObject } from './types';

const BracesIcon: IconSvgObject = [
  ["path", { d: "M16 3H17C18.1046 3 19 3.89543 19 5V10C19 11.1046 19.8954 12 21 12C19.8954 12 19 12.8954 19 14V19C19 20.1046 18.1046 21 17 21H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 3H7C5.89543 3 5 3.89543 5 5V10C5 11.1046 4.10457 12 3 12C4.10457 12 5 12.8954 5 14V19C5 20.1046 5.89543 21 7 21H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BracesIcon;
